import "./index.css";
import { registerSW } from "virtual:pwa-register";
import * as Sentry from "@sentry/react";
import { ApplicationError } from "Components/Error/ApplicationError";
import { logError } from "ErrorService";
import { bounceToNativeAppIfNeeded } from "Infrastructure/Capacitor/nativeReturnBounce";
import { initSentry } from "Infrastructure/Utils/SentryUtils";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initMixpanel } from "Infrastructure/Utils/MixpanelUtils";
import { captureAndroidTwaFlag } from "Utils/Platform/PlatformUtils";

// If a bank payment return landed here inside the iOS in-app Safari sheet, redirect to the
// moone:// scheme to resume in the app before mounting the SPA. No-op in every other context.
bounceToNativeAppIfNeeded();

// The android-app:// launch referrer is only reliably present now, before any navigation —
// persist it so isAndroidTwa() works for the rest of the session.
captureAndroidTwaFlag();

registerSW({ immediate: true });
initSentry();
initMixpanel();
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Sentry.ErrorBoundary
    showDialog
    fallback={(errorInfo) => (
      <ApplicationError error={errorInfo.error as Error} />
    )}
    dialogOptions={{ lang: "cs" }}
  >
    <Sentry.Profiler name="Moone app" updateProps={{}}>
      <App />
    </Sentry.Profiler>
  </Sentry.ErrorBoundary>,
);

window.addEventListener("error", (event) => {
  logError(event.error);
});

const setVhUnit = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
setVhUnit();

window.addEventListener("resize", () => {
  setVhUnit();
});
